import { render, staticRenderFns } from "./SvUploadDoc.vue?vue&type=template&id=5d3e36a3&scoped=true&lang=pug&"
import script from "./SvUploadDoc.vue?vue&type=script&lang=js&"
export * from "./SvUploadDoc.vue?vue&type=script&lang=js&"
import style0 from "./SvUploadDoc.vue?vue&type=style&index=0&id=5d3e36a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e36a3",
  null
  
)

export default component.exports